import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {Observer} from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpClientCustom }from './http.client';


@Injectable()
export class NumberUtils {

  public properties: any;

  public static get MILLION(): number { return 1000000.0 };
  public static get BILLION(): number { return 1000000000.0 };
  public static get LAKHS(): number { return 10000.0 };
  public static get THOUSANDS(): number { return 1000.0 };

  constructor() {
    this.properties = { BI_BASE_URL: '/bi', EPMS_BASE_URL: '/home' };
  }

  public autoScale(value: any) {
    let suffix = '';
    try {
      let x: number = parseFloat(value);
      let opr: number = x > 0 ? 1 : -1;
      x = Math.abs(x);

      if (x > NumberUtils.BILLION) {
        value = x / (NumberUtils.BILLION);
        suffix = 'Bil'
      } else if (x > NumberUtils.MILLION) {
        value = x / (NumberUtils.MILLION);
        suffix = 'Mil'
      } else if (x > NumberUtils.LAKHS) {
        value = x / (NumberUtils.THOUSANDS);
        suffix = 'K'
      }

      value = opr == -1 ? -Math.abs(value) : value;
    } catch (e) { }
    return { value: value, suffix: suffix };
  }

  public autoFormat(x: any) {
    try {
      let val = this.autoScale(x);
      return this.numberWithCommas(val.value) + " " + val.suffix;
    } catch (e) {
      return '';
    }
  }

  public numberWithCommas(val: any): any {
    try {
      let x: Number = Math.round(val * 100) / 100;

      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");

    } catch (e) {
      return 0;
    }
  }

    checkDecimalPoints(event, dp) {
    let val = event.target.value.trim();
    let dec = val.split('.');
    let decimals = "";
    if (!(/^[-]?[0-9]+(?:\.[0-9]*)?$/.test(val))) {
      event.target.value = val.slice(0, -1);
      return;
    }
    else {
      if (dec.length > 1) {
        decimals = dec[1];
      }
      else {
        return;
      }
      if (val != "" && (decimals && decimals.length > dp)) {
        console.log("Initial ", val);
        let f: any = parseFloat(val);
        let np = f.toFixed(dp);
        event.target.value = np;
        console.log("Changed ", event.target.value);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/number.utils.ts